import PropTypes from 'prop-types';

import { getAppConfig } from '../../../common/utilities';

const ErrorUserNotAssigned = ({ error }) => {
  const { name = '', message = '' } = error;
  const { path } = getAppConfig('server');
  return (
    <div className="error-okta-msg">
      <div className="error-okta-msg__h1">
        <h1 className="mega">Oops, something went wrong!</h1>
      </div>
      <p className="error-okta-msg__p">Please contact your customer representative or administrator.</p>
      <div className="error-okta-msg__box">
        <p>
          {name} : {message}
        </p>
      </div>
      <a className="error-okta-msg__button" href={`${path}/login`}>
        Back to Sign In
      </a>
    </div>
  );
};

ErrorUserNotAssigned.propTypes = {
  error: PropTypes.shape({
    message: '',
    name: ''
  }).isRequired
};

export default ErrorUserNotAssigned;
